import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetCrewScheduleUnifiedRequest, CrewScheduleUnifiedResult } from '../models/crew-schedule-unified.model';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class CrewScheduleService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroups(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  SubmitCrewSchedule(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/SubmitCrewSchedule', data);
  }

  async GetCrewScheduleList(data: any): Promise<any[]> {
    return await this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCrewScheduleList', data).toPromise();
  }
  async GetCrewScheduleListOld(data: any): Promise<any[]> {
    return await this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCrewScheduleListOld', data).toPromise();
  }

  GetCrewScheduleData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCrewScheduleList', data);
  }

  GetUserManagerList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Account/GetUserManagerList', data);
  }

  CrewUserType(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/CrewUserType', data);
  }

  GetCSUserList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCSUserList', data);
  }

  SubmitUserList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/SubmitUserList', data);
  }

  SubmitRepeatCrewSchedule(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/SubmitRepeatCrewSchedule', data);
  }

  GetShiftNowByPlantOrLine(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetShiftNowByPlantOrLine', data);
  }
  GetCrewScheduleData_LS(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCrewScheduleList_LS', data);
  }
  GetShiftNowByPlantOrLine_LS(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetShiftNowByPlantOrLine_LS', data);
  }

  // new crewSchedule APIs

  getShiftTypeMasterData(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'Shift/GetShiftTypeMaster');
  }

  getShiftMasterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getMasterShiftDataByPlant', data);
  }

  saveMasterShift(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/saveMasterShift', data);
  }
  saveShift(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/saveShift', data);
  }
  getShiftDetailsByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getShiftDetailByUnit', data);
  }
  getUsersByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getUsersByUnit', data);
  }

  getShiftByPlantModel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getShiftsByPlantModel', data);
  }

  assignShiftOpearators(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/assignShiftOpearators', data);
  }

  deleteShifts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/deleteShifts', data);
  }

  getShiftTopCardData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getShiftTopCardData', data);
  }
  changeShifts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/changeShifts', data);
  }

  downShifts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/downShifts', data);
  }

  saveHoliday(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/saveHoliday', data);
  }

  getCrewSchedule(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getCrewScheduleByUnit', data);
  }

  getUsersByPlant(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'employee/getAllEmployees');
  }
  saveEmployeeShift(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/saveEmployeeShift', data);
  }
  getEmpShiftByPlantModel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/getEmpShiftsByPlantModel', data);
  }

  downEmpShifts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/downEmpShifts', data);
  }

  deleteEmpShifts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/deleteEmpShifts', data);
  }

  getEmployeeShiftsDetailByDate(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'CrewSchedule/GetEmployeeShiftDetailListByDate', data);
  }

  // New unified crew schedule API
  GetCrewScheduleUnified(data: GetCrewScheduleUnifiedRequest): Observable<CrewScheduleUnifiedResult> {
    return this.http.post<CrewScheduleUnifiedResult>(this.baseUrl + 'CrewSchedule/GetCrewScheduleUnified', data);
  }

}
